/**
 * Returns whether or not the brand from the querystring or cookie matches the ModernLink brand.
 * Seems heavy handed but NO MORE MAGIC STRINGS...NO MORE MAGIC AT ALL!
 *
 * @param brandId The id of the brand passed from the querystring/cookie
 */
export const isModernLink =  (brandId: string): boolean => {
	const modernLinkBrandId: string = 'ModernLink';

	return brandId.toLowerCase() === modernLinkBrandId.toLowerCase();
};
